import { Component, OnInit, Input } from '@angular/core';
import { DialogService, UtilService } from '../../../shared/index'; //app/shared/index barrel;
import { EventRead } from '../../shared/event-read.model';
import { ProfileMin } from '../../../profiles/shared/profile-min.model';
import { EventTypeService } from '../../shared/event-type/event-type.service';
import { EventSignUpNotificationEmail } from '../../shared/notifications/event-signup-notification-email.model';
import { UserRead } from '../../../users/shared/user-read.model';

@Component({
  selector: 'wl-event-settings-general',
  templateUrl: 'event-settings-general.component.html',
  styleUrls: ['event-settings-general.component.css'],
  providers: [EventTypeService],
  //directives: [NotificationComponent, StateSelectorComponent, ProfileLookupComponent, TimeZoneSelectorComponent],
  //pipes: [TranslatePipe]
    standalone: false
})
export class EventSettingsGeneralComponent {
  public _utilService: UtilService;
  public _dialogService: DialogService;
  public _event: EventRead = new EventRead();
  public _eventTypeService: EventTypeService;

  public eventTypes: Array<string>;

  private _showEditor = false;
  @Input() public get showEditor() {
    return this._showEditor;
  }
  set showEditor(value: boolean) {
    this._showEditor = value;
  }

  @Input() public get event(): EventRead {
    return this._event;
  }
  public set event(value: EventRead) {
    if (this._utilService.isNotNullOrUndefined(value)) {
      this._event = value;
    }
    //if (!this._event)
    //    return;
  }

  public constructor(dialogService: DialogService, utilService: UtilService, eventTypeService: EventTypeService) {
    this._dialogService = dialogService;
    this._utilService = utilService;
    this._eventTypeService = eventTypeService;

    this.eventTypes = new Array<string>();
  }

  ngOnInit() {
    this._eventTypeService.getEventTypes().then((data: Array<string>) => {
      this.eventTypes = data;
    });
  }
  public eventProfileChanged = (profile: ProfileMin): void => {
    this.event.Venue = profile.ReportName;
    this.event.Address1 = profile.Address1;
    this.event.Address2 = profile.Address2;
    this.event.City = profile.City;
    this.event.State = profile.State;
    this.event.Zip = profile.Zip;
    this.event.Phone = profile.WorkPhone;
  };
}
